module.exports = __webpack_public_path__ + "img/circle-bg.8497dcc9.png";